// Word Wheel puzzles for English.
// letters: the seven tiles. words: common words to find (shown in the count). extra: other valid words, accepted as bonus.
// Checked against a spelling dictionary, so no word needs to be verified while playing.

export const WHEEL_EN = [
    {
        letters: 'rhadroc',
        words: 'arc arch car card char chord cord had hard orchard roach road roar',
        extra: 'ado ardor arr cad chard coda cor corr hoard hoc hod hora oar och orc rad rah rho rod',
    },
    {
        letters: 'bsemorb',
        words: 'bob bomb bomber bombers bombs bore more rob robe rose sober some sore',
        extra: 'berm berms bobs bores ebb ebbs emo ems mes mob mobs mores mos obs oms orb orbs ore ores rem robes robs roe sob somber',
    },
    {
        letters: 'abitnem',
        words: 'aim ambient anime anti ate ban bat beat bet bit eat item main man mate mean meant meat men met min mine name net tea team ten tie time',
        extra: 'abet ambit amen amine amt ant ante bait bane bani bate beam bean bent beta bin emit eta inmate mat meta mien mint mite nab nae neat nib nit tab tam tame tan tin tine',
    },
    {
        letters: 'igonkrc',
        words: 'coin cork corn grin icon iron king nor ring rink rock rocking',
        extra: 'cir cog coir coking cor corgi coring gin giro groin ink ion irk oink orc orig rig',
    },
    {
        letters: 'roalpve',
        words: 'are ear earl era leap lore love lover opera oral oval over overlap pale parole pearl per plea polar pole pro prove real rep role rope vale vapor',
        extra: 'aloe alp ape ave aver lap lav lave lop lope oar opal ope ore ova pal paleo paler par pare pave pea peal pear perv plover pol pore prov rap rave ravel reap rel rev roe rove valor vape var veal vela velar vole',
    },
    {
        letters: 'erdaidm',
        words: 'add admired aid aim aimed air are arm armed dad dare dear did die died dream dried ear era idea mad made media mid raid read red rid ride',
        extra: 'adder admire aide aided aired amid amide arid dam dame dared diadem diam dim dime dimer dire dram dread emir idem ire madder maid mar mare mead med mire mired rad raided ram ream redid rem rim rime',
    },
    {
        letters: 'hpliodn',
        words: 'dolphin don hind hip hold hop idol lion oil old pin pond',
        extra: 'din dip dpi hid hod hon ind ion lid lido lino lip loin lop nil nip nod phi plod pod poi pol',
    },
    {
        letters: 'tsidrpu',
        words: 'dirt disrupt drip dust its pit pits put puts rid rip rust sir sit spit spur stir strip stud stupid suit tip tips trip trips ups',
        extra: 'dip dips dis dist dpi dpt drips durst ids pis psi pud purist pus putrid rips rps rut ruts sip situ spud spurt std sup supt tsp turd turds',
    },
    {
        letters: 'diecnel',
        words: 'decline dice die dine end ice iced idle led lee lend lie lied line lined need nice niece',
        extra: 'cede cine deli den din eel enc incl ind lei lice lid lien nee nil',
    },
    {
        letters: 'hrettea',
        words: 'are art ate ear earth eat era hare hat hate hear heart heat heater her here rate tea tear teeth that the theater there threat three treat tree',
        extra: 'eater ere eta ether hater hatter rah rat reheat rhea rte tare tart tat tater teat tether tetra theta',
    },
    {
        letters: 'utnriac',
        words: 'act air anti arc art aunt can cant car cart cat curtain cut rain ran rant ruin run train tuna turn unit',
        extra: 'ant antic cairn cir cit ctr cur curia curt incur narc nit nut rat runic runt rut tan tarn tau tic tin tun tunic uric urn',
    },
    {
        letters: 'rrsgeub',
        words: 'bug bugs burger burgers bus sub sure surge urge urges use user',
        extra: 'beg begs berg brr bur burg burr burrs erg err errs grub grubs rebus reg rub rube rubes rubs rues rug rugs ruse surer',
    },
];